export const FIELD_APP_CONTAINER_ID = 'fieldAppContainer'

export const CLEANS_TIMELINE_PREV_DAYS = 3
export const CLEANS_TIMELINE_DATE_RANGE = 14
export const CLEANS_TIMELINE_DATE_RANGE_SHORT = 7
